var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTempGreen = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 44,
    viewBox: "0 0 17 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 29.3794V5.71851C3.78125 3.11255 5.8938 1 8.49976 1V1C11.1057 1 13.2183 3.11255 13.2183 5.71851V29.3794",
    stroke: "#92b473",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.218 29.3795C14.9188 30.7543 15.9989 32.8576 15.9989 35.215C15.9989 39.3568 12.6413 42.7144 8.49946 42.7144C4.35762 42.7144 1 39.3568 1 35.215C1 32.8576 2.0801 30.7543 3.78095 29.3795",
    stroke: "#92b473",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.33691,
    y: 19.646,
    width: 2.27947,
    height: 15.7284,
    rx: 1.13974,
    fill: "#92b473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8078 35.3971C12.8078 37.7764 10.879 39.7053 8.49961 39.7053C6.12025 39.7053 4.19141 37.7764 4.19141 35.3971C4.19141 33.0177 6.12025 31.0889 8.49961 31.0889C10.879 31.0889 12.8078 33.0177 12.8078 35.3971Z",
    fill: "#92b473"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 28.5358H12.4429",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 21.4238H12.4429",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 14.3119H12.4429",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 7.20007L12.4429 7.20007",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 26.7578H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 24.9799H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 23.2019H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 19.6459H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 17.8678H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 16.0898H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 12.5339H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 10.7559H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 8.97791H12.4654",
    stroke: "#92b473",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTempGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-temp-green.e615c8ca8a0ece9ade1decb19ece7b10.svg";